import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../../modules/material/material.module";
import { TranslateModule } from "@ngx-translate/core";

import { PhonesAdminComponent } from "./phone-admin-page.component";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { PhoneDetailComponent } from "./phoneDetail/phone-detail.component";
import { PhoneInfoComponent } from "./phoneInfo/phone-info.component";
import { PhoneLinesComponent } from "./phoneLines/phone-lines.component";
import { PhoneInfoEditComponent } from "./phoneInfo/phone-info-edit.component";
import { PhoneLinesEditComponent } from "./phoneLines/phone-lines-edit.component";
import { PhoneSetupComponent } from "./phoneSetup/phone-setup.component";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { NewCallModule } from "../../shared/components/newCall/new-call.module";
import { FormEventTrackingModule } from "../../shared/components/analytics/form-event-tracking.module";
import { AddressAutocompleteModule } from "../addressAutocomplete/address-autocomplete.module";
import { PhoneAdditionalDialogComponent } from "./phoneAdditionalDialog/phone-additional-dialog.component";
import { PhonesRoutingModule } from "@onsip/web/features/administrators/phones/phonesRouting.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { PhonesEmptyDataComponent } from "./phones-empty-data/phones-empty-data.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    TableModule,
    OnsipFormsModule,
    HeaderModule,
    RouterModule,
    PipesModule,
    NewCallModule,
    FormEventTrackingModule,
    AddressAutocompleteModule,
    PhonesRoutingModule,
    TableDataLoadContainerModule,
    LoadingContainerComponent
  ],
  declarations: [
    PhonesAdminComponent,
    PhoneDetailComponent,
    PhoneInfoComponent,
    PhoneInfoEditComponent,
    PhoneLinesComponent,
    PhoneLinesEditComponent,
    PhoneSetupComponent,
    PhoneAdditionalDialogComponent,
    PhonesEmptyDataComponent
  ]
})
export class PhonesModule {}
